import React, { forwardRef, useMemo } from "react";
import { Grid } from "components/Grid";
import { useTranslation } from "react-i18next";
import { DataGridRef } from "devextreme-react/data-grid";
import { TRole } from "types/dto";
import { TransparentLoading } from "components/TransparentLoading";

type TProps = {
  rolesData: TRole[];
  isLoading?: boolean;
};
const RolesGrid = forwardRef<DataGridRef, TProps>((props, ref) => {
  const { isLoading, rolesData } = props;
  const { t } = useTranslation();

  const columns = useMemo(() => {
    const _columns: any[] = [
      {
        dataField: "id",
        caption: t("id"),
      },
      {
        dataField: "name",
        caption: t("name"),
      },
    ];
    return _columns;
  }, [t]);

  return (
    <>
      <div className={"w-full flex gap-x h-full"}>
        {isLoading && <TransparentLoading />}
        <Grid
          ref={ref}
          gridKey={"id"}
          dataSource={rolesData}
          columns={columns}
          hasSearchPanel={false}
          hasPagination={true}
          hasGroupingFeatures={false}
          hasFilterBuilder={false}
          hasSelectableRow={true}
        />
      </div>
    </>
  );
});

export default RolesGrid;
